import { Loader as LoaderIcon } from 'lucide-react';

/**
 * Page-level loading state — a centred spinner in the normal content column,
 * for a route that has nothing to show yet.
 *
 * Uses the same Lucide `<Loader />` as `LoadingOverlay`, deliberately: the app
 * has one spinner glyph, never two competing ones. The difference is placement,
 * not appearance — `LoadingOverlay` covers the viewport, this sits in the flow.
 */
const Loader = () => {
  return (
    <div className="container max-w-4xl mx-auto py-16">
      <div className="flex items-center justify-center min-h-100">
        <LoaderIcon className="h-8 w-8 animate-spin text-primary" />
      </div>
    </div>
  );
};

export default Loader;
